import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('price-zone')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-48 pb-16 md:pt-48 md:pb-24 px-4 relative overflow-hidden" data-id="element-52">
      {/* Subtle background glow */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-warm/10 rounded-full blur-[100px] -z-10 pointer-events-none" data-id="element-53"></div>

      <div className="max-w-5xl mx-auto flex flex-col items-center gap-16" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center" data-id="element-55">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-[1.4] md:leading-snug text-main mb-6" data-id="element-56">
            Tu sistema nervioso lleva demasiado tiempo en alerta.
            <br data-id="element-57" />
            El protocolo de 7 noches que te enseña a soltar.
          </h1>
          <p className="text-2xl md:text-3xl font-serif font-semibold text-warm mb-6" data-id="element-58">
            Para mujeres que duermen pero no descansan.
            <br data-id="element-59" />
            Sin meditación. Sin apps. Solo 5 minutos antes de dormir.
          </p>
          <p className="text-xl md:text-2xl font-serif text-muted mb-8 opacity-90" data-id="element-60">
            Aunque Sientas que tu Cabeza Tiene 45 Pestañas Abiertas.
          </p>
          <p className="text-base md:text-lg text-muted mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-61">
            El protocolo de biohacking de 7 días diseñado para mujeres
            profesionales y emprendedoras que no tienen tiempo para meditar,
            pero necesitan volver a dormir en paz{' '}
            <strong className="text-warm font-semibold" data-id="element-62">HOY</strong>.
          </p>

          <div className="flex justify-center" data-id="element-63">
            <CTAButton text="QUIERO QUE MI CUERPO APRENDA A SOLTAR" onClick={scrollToPricing} data-id="element-64" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="w-full max-w-lg relative" data-id="element-65">
          <div className="absolute inset-0 bg-gradient-to-tr from-warm/20 to-transparent rounded-2xl transform translate-x-4 translate-y-4 -z-10" data-id="element-66"></div>
          <img src="https://cdn.magicpatterns.com/uploads/vijgRXF5pqbqLTjUUWvEr5/imagen_para_shopify.webp" alt="Mente en Calma - Libro, Audio SOS y Checklists en todos los dispositivos" className="w-full h-auto rounded-2xl shadow-2xl border border-white/10 object-cover aspect-square" data-id="element-67" />
        </motion.div>
      </div>
    </section>;
}